import * as React from 'react';

import { useToastState } from '#states/hooks.js';

import { IconSizes, MaterialIcon } from './MaterialIcon.js';
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from './toast.js';

function ToastVariantIcon({ variant }: { variant?: 'default' | 'destructive' | 'success' }) {
  if (variant === 'success') {
    // The toast's own text colour: these toasts are a solid fill of their colour.
    return <MaterialIcon icon="check_circle" className="shrink-0" size={IconSizes.sm} />;
  }
  if (variant === 'destructive') {
    return <MaterialIcon icon="error" className="shrink-0" size={IconSizes.sm} />;
  }
  return null;
}

export function Toaster() {
  const toastState = useToastState();

  return (
    <ToastProvider>
      {toastState.toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-start gap-2">
              <ToastVariantIcon variant={variant} />
              <div className="grid gap-1 min-w-0">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            {!action && <ToastClose />}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
